import {FILTER_NAMES} from '../base.js'

export const FILTERS_HELP_TEXTS = {
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: 'FILTERS.ELECTRIC_CHARGING_TIME_FAST_MODE.HELP_TEXT',
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: 'FILTERS.ELECTRIC_CHARGING_TIME_STANDARD_MODE.HELP_TEXT'
}
